export default function closeWarning() {
  const warnings = document.querySelectorAll(".warning");

  warnings.forEach((element) => {
    const closeButton = element.querySelector(".js-close");

    closeButton.addEventListener("click", () => {
      // eslint-disable-next-line no-param-reassign
      element.style.display = "none";
    });
  });
}
